export default __webpack_public_path__ + "static/media/googlestore.cd631204.png";